'use strict';

import momentTz from 'moment-timezone';

export const getDataObject = state => {
  let proxyHolderName = state.proxy.proxyHolder.name;
  // Check if we need to set to default holder name
  if (proxyHolderName === 'default') {
    proxyHolderName = state.meeting.meeting.defaultHolder;
  }

  // Check if we need to append custom dropdown selection to the proxy holder's name
  if (state.proxy.proxyDropdownSelection) {
    proxyHolderName += ', ' + state.proxy.proxyDropdownSelection;
  }

  // Build the answers array
  const answers = state.questions.questions.reduce((arr, question) => {
    // Only add answers for which the voter was eligible to vote on
    if (question.isVoterEligible) {
      let answerObj = {
        id: question.id,
        order: question.order,
        type: question.type,
        isResident: state.resident.isResident || 'no',
        name: question.name,
        proxyPreText: question.proxyPreText,
        proxyPostText: question.proxyPostText
      };

      // Check if type is owner-occupied election, if not resident, then clear vote
      if (
        question.type === 'owner-occupied' &&
        (!state.resident.isResident || state.resident.isResident === 'no')
      ) {
        answerObj.vote = [];
      } else {
        answerObj.vote =
          question.vote.selection[0] === ''
            ? [question.vote.option[0]]
            : question.vote.selection;
      }

      arr.push(answerObj);
    }
    return arr;
  }, []);

  // Build the data object to send
  return {
    shortCode: state.meeting.meeting.shortCode,
    address: state.ownership.address,
    unit: state.ownership.unit,
    holderName: proxyHolderName,
    name: state.contact.name,
    email: state.contact.email,
    isEmailOptIn: state.comms.value === 'yes',
    trackingCode: state.trackingCode,
    answers,
    proxyAbstainOption: state.proxy.proxyAbstainOption,
    customSignature: state.customSignature
  };
};

export const formatDate = (date, timezone = 'America/Toronto', format) => {
  return momentTz(date)
    .tz(timezone ? timezone : 'America/Toronto')
    .format(format);
};

// Checking for abstain-all scenario
export const checkAbstain = (voteArray, isResident) => {
  // 1) Each question must be checked for the voter
  // 2) Final determinism is store in both 'option' and 'selection'
  // 3) 'option' stores the decision for abstains or deferral
  // 4) 'selection' stores the choice from the list of candidates/options
  // Special case: By-laws list both abstain and deferral options in the list unlike elections
  // Special case: Director-removals does not prompt the abstain/defer modal when no selection is made

  // Run through each question and check for any selections made from the list of candidates/options
  let votes = voteArray.map(function(item) {
    // First check and return any valid selections made
    if (Array.isArray(item.vote.selection) && item.vote.selection[0] !== '') {
      return {vote: item.vote.selection.join(''), type: item.type};
    }

    // When no selections are made, they will have had to choose from the option modal to abstain or defer
    if (Array.isArray(item.vote.option) && item.vote.option[0] !== '') {
      return {vote: item.vote.option.join(''), type: item.type};
    }

    return {vote: item.vote.selection, type: item.type};
  });

  for (let i = 0; i < votes.length; i++) {
    if (
      votes[i].type === 'substitute-elections-oo' ||
      votes[i].type === 'owner-occupied'
    ) {
      if (isResident === 'Yes') {
        // Condition for array to check if not ['']
        if (Array.isArray(votes[i].vote) && !!votes[i].vote.toString()) {
          return false;
        } else if (
          // Condition to check for string if not empty or abstain
          typeof votes[i].vote === 'string' &&
          votes[i].vote !== '' &&
          votes[i].vote !==
            'I abstain from voting and my proxy shall not vote on this matter'
        ) {
          return false;
        }
      }
    } else {
      // Check for other question types
      if (
        votes[i].vote !== '' &&
        votes[i].vote !== 'abstain' &&
        votes[i].vote !==
          'I abstain from voting and my proxy shall not vote on this matter'
      ) {
        return false;
      }
    }
  }

  return true;
};

// Sanitize candidate names for duplicate comparison
export const sanitizeCandidate = candidate => {
  return candidate
    .replace(/\s\s+/g, ' ')
    .trim()
    .toLowerCase();
};

// Create a string of the list of subgroups which
// are eligible to vote on a restricted question
export const subgroups = question => {
  let subgroup = '';

  for (let i = 0; i < question.restrictions.length; i++) {
    if (i !== 0) {
      subgroup += ' or ';
    }
    const restriction = question.restrictions[i];

    const key = Object.keys(restriction)[0];
    if (key === 'owner_occupied') {
      subgroup += 'owner-occupied units';
    } else {
      subgroup += `${key}: ${restriction[key]}`;
    }
  }
  return subgroup.toUpperCase();
};



// WEBPACK FOOTER //
// ./src/vuex/helpers.js